import React from 'react';
import { motion } from 'framer-motion';
import './About.css';

const About = () => {
return (
    <motion.section
        id="about"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        className="about"
    >
        <h2>About Me</h2>
        <p>
        I am a skilled full-stack developer with expertise in React, Node.js, Flutter, Shopify, and modern web technologies. 
        Passionate about building scalable, efficient, and user-friendly applications, I specialize in delivering seamless user experiences across web and mobile platforms. 
        With a strong foundation in both front-end and back-end development, I continuously learn and adapt to emerging technologies to create high-quality, innovative solutions.


        </p>

        <a href="/assets/Sanoj_Resume.pdf" target="_blank" rel="noopener noreferrer" className="link">
            Have a look on my CV
        </a>
        
    </motion.section>
);
};

export default About;
